<script>
export default {
  name: 'Title2Logo',
  props: {
    headline: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div class="title-box">
    <el-image
      class="id-2-logo"
      :src="require('imgs/modules/dialog-modules/id-2-logo-left.png')"
      alt="logo"
    />
    <p class="title">{{ headline }}</p>
    <el-image
      class="id-2-logo"
      :src="require('imgs/modules/dialog-modules/id-2-logo-right.png')"
      alt="logo"
    />
  </div>
</template>

<style lang="scss" scoped>
.title-box {
  max-width: 570px;
  display: flex;
  align-items: flex-start;
  .id-2-logo {
    width: 51px;
    height: 41px;
  }
  .title {
    max-width: 580px;
    font-size: 23px;
    font-weight: bold;
    color: #000;
    line-height: 29px;
    text-align: center;
    padding: 8px 30px 0;
    box-sizing: border-box;
  }
}
</style>
